import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { SiteMapNode } from '@/models';
import { environment } from '@/environments/environment';

@Injectable({
  providedIn: 'root',
})
export class SiteMapService {
  constructor(private httpClient: HttpClient) {}

  public loadSiteMapForUser(userId: number, clientId: number) {
    return this.httpClient.get<SiteMapNode[]>(
      `${environment.serviceEndpoints.sitemap}?clientId=${clientId}&userId=${userId}`,
    );
  }

  public loadSiteMapForAdmin() {
    return this.httpClient.get<SiteMapNode>(
      `${environment.serviceEndpoints.sitemap}admin`,
    );
  }
}
